import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { quoteIdSelector } from 'ctm-selectors';
import { resultsActions } from 'ctm-components';
import { apiAction, pageContext, getPathWithQueryString } from 'ctm-util-functions';

const withNavigateToMoreInfoPage = (Component) => {
    class WithState extends React.PureComponent {

        render() {
            const { dispatchNavigation, quoteId, ...rest } = this.props;

            const navigateToMoreInfoPage = (productId) => {
                dispatchNavigation(productId, quoteId);
                pageContext.getProps().browserHistory.push(getPathWithQueryString('/car-insurance/journey/more_info'));
            };

            return <Component { ...rest } navigateToMoreInfoPage={navigateToMoreInfoPage} />;
        }

    }

    WithState.propTypes = {
        dispatchNavigation: PropTypes.func,
        quoteId: PropTypes.number
    };

    return connect(mapStateToProps, mapDispatchToProps)(WithState);
};

// @see results_link.js
const mapDispatchToProps = (dispatch) => ({
    dispatchNavigation: (productId, quoteId) => {
        dispatch(resultsActions.setProductId(productId));
        dispatch(resultsActions.setQuoteId(quoteId));

        dispatch({
            type: 'MORE_INFO_OPEN'
        });
        const api = {
            failureType: 'non-fatal',
            requestAction: 'MORE_INFO',
            requestPayload: 'lead',
            type: 'POST',
            url: '/event' };
        dispatch(apiAction(api, pageContext.getProps().pageState));
    }
});

const mapStateToProps = (state) => {
    const quoteId = quoteIdSelector(state) || 0;
    return {
        quoteId
    };
};

export { withNavigateToMoreInfoPage };
